import { createSlice } from '@reduxjs/toolkit';

import { getBrokerDashboardData } from './brokerDashboard.actions';

const initialState = {
  dashboardData: {},
  isLoadingDashboardData: false,
};

const brokerDashboard = createSlice({
  name: 'brokerDashboard',
  initialState,
  reducers: {
    clearBrokerDashboardState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getBrokerDashboardData.pending, (state) => {
      state.isLoadingDashboardData = true;
    });
    builder.addCase(getBrokerDashboardData.fulfilled, (state, action) => {
      state.dashboardData = action.payload;
      state.isLoadingDashboardData = false;
    });
    builder.addCase(getBrokerDashboardData.rejected, (state) => {
      state.isLoadingDashboardData = false;
    });
  },
});

export const { clearBrokerDashboardState } = brokerDashboard.actions;

export default brokerDashboard.reducer;
